import { Typography, Box, CircularProgress, Divider, Button, Stack, InputAdornment, Autocomplete, OutlinedInput, FormControl, InputLabel } from "@mui/material"
import { useState, useEffect, useContext } from "react"
import { GenerateBill } from "../../global/API"
import { ToolContext } from "../../../../core/context/ToolContext"
import { BranchRead } from "../../global/API";
import { CstmTextField } from "../../../../core/global/forms/CstmTextField";

export const Index = () => {

const [transaction, setTransaction] = useState({
    name: "",
    date_from: "",
    date_to: "",
    dp: 0,
})
const [discount, setDiscount] = useState(0)
const [billItems, setBillItems] = useState([])
const [billLoading, setBillLoading] = useState(false)


const {tool_state, setup_state} = useContext(ToolContext)
const { __SESSION } = tool_state
const { branchData } = setup_state


    const FetchBill = async (transaction) => {
    
        try {
            setBillLoading(true)
            let qsp = {
                from: transaction.date_from,
                to: transaction.date_to,
                code: transaction.name,
                branch_id: transaction.branch_id,
                company_id: __SESSION.data.uaccess[0].company_id
            }

            let res = await GenerateBill(qsp)

            if (res) {
                setBillItems(res)
            }else{
                setBillLoading(false)
            }

        } catch (error) {
            console.error(error)
        } finally {
            setBillLoading(false)
        }
    }

    const total = billItems.reduce(
        (sum, item) => sum + parseFloat(item.total_amount),
        0
    )

    const discountAmount = total * (discount / 100)
    const netForPayment = total - discountAmount
    
    const inputChangeHandler = (e, val, key) =>{
        const name = key;
        const value = (val === null ? 0 : (key === 'branch_id' ? val.company_branch_id : val.id) );
        setTransaction({...transaction, [name]:value,})
    }

    const handleDiscountChange = (e) => {
        const value = e.target.value;
        const regex = /^(0|[1-9]\d*)(\.\d*)?$/;

        if (!regex.test(value) && value !== "") {
            return;
        } 

        setDiscount(value);
    };

    const __init = async() => {
        let res = await BranchRead(__SESSION.data.uaccess[0].company_id, 'active')
        if (res) branchData.set([{id:0, company_branch_id:0,  name:'All', code:'000', active:1,}, ...res])
    }

    useEffect(() => {
        __init()
        //eslint-disable-next-line
    }, []);

    return (
    <Box sx={{height: "100%", display: "flex", flexDirection:"column", gap: 4}}>

        <Box sx={{ width: "100%", bgcolor: "#fff", p: 3, borderRadius: 4, display: "flex", gap: 2}}>
            <Autocomplete   
                fullWidth
                options={branchData.data}
                getOptionLabel={(option) => option.name}
                onChange={(e, value) => inputChangeHandler(e, value, 'branch_id')}
                value={ transaction.branch_id === '' ? null : branchData.data.find((f) => f.company_branch_id === transaction.branch_id) || null} 
                renderInput={(params) => (
                    <CstmTextField {...params} label="Branch" placeholder="Branch" />
                )}
            />

            <CstmTextField
                fullWidth
                label="Customer Name" 
                placeholder="Customer Name"
                value={transaction?.name || ""}
                onChange={(e) =>
                    setTransaction({ ...transaction, name: e.target.value })
                }
            />

            <CstmTextField
                fullWidth
                label="Date from" 
                type="date"
                value={transaction?.date_from || ""}
                onChange={(e) => setTransaction({ ...transaction, date_from: e.target.value,})}
            />

            <CstmTextField
                fullWidth
                label="Date to" 
                type="date"
                value={transaction?.date_to || ""}
                onChange={(e) => setTransaction({ ...transaction, date_to: e.target.value,})}
            />

            <FormControl fullWidth>
                <InputLabel>Discount</InputLabel>
                <OutlinedInput
                    label="Discount"
                    inputProps={{ textAlign: "right" }}
                    sx={{ borderRadius: 3 }}
                    value={discount}
                    onChange={(e) => handleDiscountChange(e)}
                    endAdornment={
                        <InputAdornment position="end">
                            %
                        </InputAdornment>
                    }
                />
            </FormControl>

            <Button
                fullWidth
                variant="contained"
                onClick={() => FetchBill(transaction)}
                disabled={!transaction?.name || !transaction?.date_from || !transaction?.date_to}
                sx={{p: 2, borderRadius: 3}}
            >
                Generate
            </Button>
        </Box>
        
            <Box sx={{ flex: 1, bgcolor: "#fff", p: 5, fontFamily: "monospace", display: "flex", flexDirection: "column", borderRadius: 4}} >
                {billItems.length > 0 &&        
                    <Box sx={{width: "70%", height: "100%", maxWidth: "800px", margin: "auto", border: 1, borderRadius: 4, borderColor: "#8d8d8dff", p: 2}}>
                        <Box>
                            <Stack mb={2}>
                                <Typography variant="h6" align="center">
                                    MIRA Agropark
                                </Typography>

                                <Typography fontStyle="italic" align="center" gutterBottom>
                                    Sitio Ibucao, Tanay, Rizal
                                </Typography>

                                <Typography variant="body2">
                                    Date from: {transaction.date_from}
                                </Typography>
                                <Typography variant="body2">
                                    Date to: {transaction.date_to}
                                </Typography>

                                <Typography variant="body2">
                                    Name: {transaction?.name}
                                </Typography>
                            </Stack>

                            <Divider sx={{ mb: 2 }} />

                            <Typography variant="h6" align="center" gutterBottom>
                                STATEMENT OF ACCOUNT
                            </Typography>

                            <Divider sx={{ my: 2 }} />

                            {billLoading ? (
                                <Box textAlign="center">
                                    <CircularProgress size={28} />
                                </Box>
                            ) : (
                                <Box>
                                    {billItems.map((item, index) => (
                                        <Box key={index} mb={1}>
                                            <Typography variant="body2">
                                                {item.alias}
                                            </Typography>
                                            <Box
                                                display="flex"
                                                justifyContent="space-between"
                                                fontSize="0.85rem"
                                            >
                                                <span>
                                                    {item.total_quantity} x
                                                </span>
                                                <span>
                                                    ₱{parseFloat(item.total_amount).toFixed(2)}
                                                </span>
                                            </Box>
                                        </Box>
                                    ))}
                                </Box>
                            )}
                        </Box>

                        <Box>
                            <Divider sx={{ my: 2 }} />

                            <Box display="flex" justifyContent="space-between">
                                <Typography>Total</Typography>
                                <Typography>₱{total.toFixed(2)}</Typography>
                            </Box>

                            <Box display="flex" justifyContent="space-between">
                                <Typography>Discount ({discount}%)</Typography>
                                <Typography>- ₱{discountAmount.toFixed(2)}</Typography>
                            </Box>

                            <Divider sx={{ my: 1 }} />

                            <Box display="flex" justifyContent="space-between">
                                <Typography fontWeight="bold">Net for Payment</Typography>
                                <Typography fontWeight="bold">
                                    ₱{netForPayment.toFixed(2)}
                                </Typography>
                            </Box>
                        </Box>
                    </Box>
                }
            </Box>
    </Box>
)
}